import { render, staticRenderFns } from "./FactText.vue?vue&type=template&id=01686bba&scoped=true&"
import script from "./FactText.vue?vue&type=script&lang=ts&"
export * from "./FactText.vue?vue&type=script&lang=ts&"
import style0 from "./FactText.vue?vue&type=style&index=0&id=01686bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01686bba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VLayout,VTextField})
